// import { makeObservable } from 'mobx'
import { Slide } from './Slide'

export class MeetingResultsSlide extends Slide {
  afterConstructor() {}
}
